module.exports = __webpack_public_path__ + "8a3932be303b1288e53f1bfded9aa58c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-baseball.png
// module id = 1946
// module chunks = 0